import { Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { map, Observable, take } from 'rxjs';
import { AppRoutes, AUTH_CLIENT_TOKEN, AuthClientProvider } from '@core';

export const isAuthedGuard = (): Observable<UrlTree | boolean> => {
  const authClientProvider: AuthClientProvider = inject(AUTH_CLIENT_TOKEN);
  const router: Router = inject(Router);

  return authClientProvider.isAuthed$.pipe(
    take(1),
    map((user: boolean) => (user ? true : router.createUrlTree([AppRoutes.AUTH])))
  );
};
